export const POST_API = async (url, bodyData, access_token) => {
    return await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${access_token}`,
      },
      body: JSON.stringify(bodyData),

    })
      .then((res) => res.json())
      .then((res) => {
        return res;
      });
  };

export const GET_API = async (url, access_token) => {
  try {
    console.log('GET_API called with URL:', url);
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${access_token}`,
      },
    });

    console.log('Response status:', response.status, response.statusText);
    console.log('Response headers:', response.headers);

    const textResponse = await response.text();
    console.log('Raw response:', textResponse);

    // Try to parse as JSON
    try {
      const jsonResponse = JSON.parse(textResponse);
      console.log('Parsed JSON response:', jsonResponse);
      return jsonResponse;
    } catch (parseError) {
      console.error('Failed to parse response as JSON:', parseError);
      console.log('Response text:', textResponse);
      return {
        success: false,
        message: 'Invalid response format from server',
        rawResponse: textResponse
      };
    }
  } catch (error) {
    console.error('GET_API error:', error);
    throw error;
  }
};

